module.exports = __webpack_public_path__ + "img/SketchPng5883156b8da4043741c187d56b545a4c73f5275362e552ecb4ccd915f82b670a.f3fcbcc9.png";